import React from "react";
import Image from "next/image";
import { HIDDEN_COST_DATA } from "@/constastants/TailSpendConstants";
import styles from "./TailSpendManagement.module.scss";

function TailSpendHiddenCosts() {
  return (
    <div className={styles.hiddenCosts}>
      <h2 className={styles.hiddenCostsHeading}>
        The Hidden Cost of Tail Spend
      </h2>
      <div className={styles.hiddenCostsGrid}>
        {HIDDEN_COST_DATA.map((item) => (
          <div key={item.id} className={styles.costCard}>
            <div className={styles.costIcon}>
              <Image src={item.icon} alt={item.title} width={24} height={24} />
            </div>
            <div className={styles.costCardContent}>
              <p className={styles.costCardTitle}>{item.title}</p>
              <p className={styles.costCardDescription}>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TailSpendHiddenCosts;
